import React from 'react';

import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ReactDOM from 'react-dom/client';

import Home from './pages/home/Home';
import Contact from './pages/contact/Contact.js';
import About from './pages/about/About';
import Experience from './pages/Experience';
import Papers from './pages/papers/Papers';
import Projects from './pages/projects/Projects';
import ProjectPage from './pages/projects/ProjectPage.js';
import ErrorPage from './pages/errors/ErrorPage';

import UnderConstructionPage from './pages/errors/UnderConstructionPage.js';




import './index.css';
import './App.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/about",
    element: <About />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/experience",
    element: <Experience />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/projects",
    element: <Projects />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/papers",
    element: <Papers />,
    errorElement: <ErrorPage />,
  },

  {
    path: "/contact",
    element: <Contact />,
    errorElement: <ErrorPage />,
  },
  {
    path: "*",
    element: <ErrorPage />,
  },
  {
    path: "/projects/:slug",
    element: <ProjectPage />,
    // element: <UnderConstructionPage />,

  },
  {
    path: "/papers/:slug",
    element: <UnderConstructionPage />,
    errorElement: <ErrorPage />,
  },

]);

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />

  </React.StrictMode>
);


reportWebVitals();
